import React from 'react'
import { Button, Spinner } from '@notino/react-styleguide'

// hooks
import useMessages from '../../hooks/useMessages'

// utils
import { SCROLLBAR_OPTIONS } from '../../utils/helper'
import { FORM } from '../../utils/enums'

// styles
import * as SC from './FilterSidebarFooterStyles'

// types
type SidebarFooterProps = {
	isVisible?: boolean
	extraContent?: React.ReactNode
	isSlider?: boolean
	label?: React.ReactNode
	loading?: boolean
	formId: FORM
}

// component
const SidebarFooter = (props: SidebarFooterProps) => {
	const { isVisible, extraContent, isSlider = true, label, loading, formId } = props
	const { messages } = useMessages()

	// NOTE: Button from Notino style-guide library doesn't recognize "form" as a prop, however, when passed to the component, it works fine
	const unknownButtonProps = {
		form: formId
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} as any

	return (
		<SC.SidebarFooterWrapper $isVisible={isVisible} {...(!isVisible ? { inert: '' } : undefined)}>
			{extraContent && isSlider && (
				<SC.FooterSlider options={SCROLLBAR_OPTIONS}>
					<SC.FooterSliderContent>{extraContent}</SC.FooterSliderContent>
				</SC.FooterSlider>
			)}
			{extraContent && !isSlider && <SC.FooterExtraContent>{extraContent}</SC.FooterExtraContent>}
			<SC.FooterCtaButtonWrapper>
				<Button {...unknownButtonProps} fullWidth disabled={loading || !isVisible} type={'submit'}>
					{loading ? <Spinner size={16} color={'icon.disabled'} /> : label || messages.Apply}
				</Button>
			</SC.FooterCtaButtonWrapper>
		</SC.SidebarFooterWrapper>
	)
}

export default SidebarFooter
